import { Component, ElementRef, inject, OnInit, Signal, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { selectServices } from '../../store/selectors/app.selectors';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { ServiceListItem } from '../../services/service.common.model';
import { environment } from '../../../environments/environment';
import { CivicBudgetService } from '../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    RouterModule,
    ReactiveFormsModule,
    HeaderComponent,
    CommonModule,
    FooterComponent,
    FormsModule
  ],
  templateUrl: './main-page.component.html'
})
export class MainPageComponent implements OnInit {

  public activeTab: any;

  @ViewChild('servicesTab', { static: true })
  servicesTab: ElementRef | undefined;

  @ViewChild('budgetTab', { static: true })
  budgetTab: ElementRef | undefined;

  public services: Signal<ServiceListItem[]> = this.store$.selectSignal(selectServices);

  public civicBudgets = toSignal(inject(CivicBudgetService).getCivicBudgetCollectionCivicBudgetCollection({
    pagination: true,
    itemsPerPage: 6
  }));

  public form = new FormGroup({
    query: new FormControl('', [Validators.required])
  });

  constructor(
    private store$: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (!environment.localEnv) {
      document.body.classList.add('js-show-gov-menu');
    }
  }

  public onSearch(): void {
    if (this.form.valid) {
      this.router.navigate(['e-uslugi'], { queryParams: { 'query': this.form.value.query } });
    }
  }

  public ngOnInit(): void {
    switch (true) {
      case this.route.snapshot.fragment === 'budgetTab': {
        this.activeTab = this.budgetTab?.nativeElement;
        break;
      }
      case this.route.snapshot.fragment === 'servicesTab': {
        this.activeTab = this.servicesTab?.nativeElement;
        break;
      }
      default: {
        this.activeTab = this.servicesTab?.nativeElement;
      }
    }
  }
}
